export const transition = { 
    duration: .25, 
    ease: [.56, .03, .12, 1.04]
};

export const variants = {
    // general show/hide variants
    hide: {
        opacity: 0,
        pointerEvents: 'none'
    },
    show: {
        opacity: 1,
        pointerEvents: 'initial'
    },
    // required toggle variants
    toggleWrapOff: {
        border: '1px solid #ccc',
        backgroundColor: '#eee'
    },
    toggleWrapOn: {
        border: '1px solid #607ca7',
        backgroundColor: '#edf0f6'
    },
    toggleOff: {
        left: '.16rem',
        backgroundColor: '#bbb'
    },
    toggleOn: { 
        left: '1rem',
        backgroundColor: '#607ca7'
    },
    // icon rating variants
    iconNormal: {
        borderBottom: '2px solid transparent',
        cursor: 'intial',
        padding: 0,
        backgroundColor: '#fff',
    },
    iconEdit: {
        borderBottom: '2px solid #607ca7',
        cursor: 'pointer',
        padding: '.25rem .15rem .2rem 0',
        backgroundColor: '#edf0f6'
    },
    numberNormal: {
        borderBottom: '2px solid transparent',
        padding: 0,
        backgroundColor: '#fff',
    },
    numberEdit: {
        borderBottom: '2px solid #607ca7',
        padding: '.25rem',
        backgroundColor: '#edf0f6'
    },
    hideMenu: {
        opacity: 0,
        transition: {
            duration: 0
        }
    },
    showMenu: {
        opacity: 1
    },
    // field name variants
    titleNormal: (custom) => ({
        background: 'transparent',
        backgroundColor: custom?.backgroundColor ?? '#fff',
        borderBottom: custom?.borderBottom ?? '2px solid transparent',
        paddingLeft: '0',
        marginBottom: '0'
    }),
    titleEdit: (custom) => ({
        background: 'transparent',
        backgroundColor: custom?.backgroundColor ?? '#edf0f6',
        borderBottom: custom?.borderBottom ?? '2px solid #607ca7',
        paddingLeft: '.25rem',
        marginBottom: '.25rem'
    }),
    // checkbox variants
    notChecked: {
        backgroundColor: '#fbfbfb',
        border: '1px solid #ccc'
    },
    checked: {
        backgroundColor: '#edf0f6',
        border: '1px solid #607ca7'
    },
    // checklist
    optionNormal: {
        backgroundColor: '#fff',
        borderBottom: '2px solid transparent',
        height: '1.75rem',
    },
    optionEdit: {
        backgroundColor: '#edf0f6',
        borderBottom: '2px solid #607ca7',
        height: '2rem'
    },
}